import React from 'react'
import './DotStatus.scss'

const DotStatus = (props) => {
  let operatorStatusDotColor = ''

  switch (props.operatorStatus.toLowerCase()) {
    case 'online':
      operatorStatusDotColor = 'green-dot'
      break

    case 'offline':
      operatorStatusDotColor = 'red-dot'
      break

    case 'absent':
      operatorStatusDotColor = 'yellow-dot'
      break

    default:
      break
  }

  return <span className={`dot ${operatorStatusDotColor}`}></span>
}

export default DotStatus
